import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useCheckShowBalance } from 'common/hooks/use-check-show-thanks-balance';
export var CheckRenderBalance = function (_a) {
    var children = _a.children, wallet = _a.wallet, checkRender = _a.checkRender;
    var showBalance = useCheckShowBalance(wallet);
    if (!showBalance) {
        return null;
    }
    if (checkRender && !checkRender()) {
        return null;
    }
    return _jsx(_Fragment, { children: children });
};
